import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Auth.css";
import Logo from "../Assets/BooksCompl.png";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState({ content: "", type: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setMessage({ content: "Email is required", type: "danger" });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage({ content: "Please enter a valid email address", type: "danger" });
      return;
    }

    setLoading(true);
    setMessage({ content: "", type: "" });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/forgot-password`,
        {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to send password reset email");
      }

      setMessage({
        content: data.message || "Password reset link sent to your email. Please check your inbox.",
        type: "success",
      });

      setEmail("");

    } catch (error) {
      console.error("Password reset error:", error);
      setMessage({ 
        content: error.message || "An error occurred while sending reset instructions", 
        type: "danger" 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid forget-password-container fade-in">
      <div className="main-logo">
        <img src={Logo} alt="Logo" className="logo-img" />
      </div>
      
      <div className="row justify-content-center align-items-center vh-100">
        <div className="col-lg-6 col-md-8 col-sm-10 forget-password-card p-4">
          <div className="text-center mb-4">
            <h2>Forgot Password?</h2>
            <p className="text-muted">
              Enter your email address and we'll send you a link to reset your password.
            </p>
          </div>

          {message.content && (
            <div 
              className={`alert alert-${message.type} alert-dismissible fade show`} 
              role="alert"
            >
              {message.content}
              <button 
                type="button" 
                className="btn-close" 
                onClick={() => setMessage({ content: "", type: "" })}
                aria-label="Close"
              ></button>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3 position-relative">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                className="form-control forget-password-input"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100 py-2"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span 
                    className="spinner-border spinner-border-sm me-2" 
                    role="status" 
                    aria-hidden="true"
                  ></span>
                  Sending...
                </>
              ) : (
                "Send Reset Link"
              )}
            </button>
          </form>

          <div className="text-center mt-3">
            <p className="mb-0">
              Remember your password?{"  "}
              <a 
                href="/login" 
                className="text-primary text-decoration-none"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/login");
                }}
              >
                Login here
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForgetPassword;